import { useEffect, useRef, useState } from 'react';
import { useAppContext } from 'hooks/useAppContext';

interface UsePrismaticEmbedOptions {
  embedFunction: (organizationId: string, selector: string) => Promise<void>;
  containerId: string;
}

export const usePrismaticEmbed = ({
  embedFunction,
  containerId
}: UsePrismaticEmbedOptions) => {
  const { selectedOrganization } = useAppContext();
  const containerRef = useRef<HTMLDivElement>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!selectedOrganization || !containerRef.current) return;

    let mounted = true;
    const container = containerRef.current;

    const loadEmbed = async () => {
      try {
        setError(null);
        await embedFunction(selectedOrganization.id, `#${containerId}`);
      } catch (err) {
        if (mounted) {
          setError('Failed to load integration. Please try again.');
        }
      }
    };

    loadEmbed();

    return () => {
      mounted = false;

      // Clean up iframe
      const iframe = container?.querySelector('iframe');
      iframe?.remove();
    };
  }, [selectedOrganization, containerId, embedFunction]);

  return { containerRef, error };
};
